import React, { useState, useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { getBranchOwner } from "@config";
import { aiReadProduct, aiRegisterRecipient, aiRegisterProductsBatch, aiTranscribeAudioNFe } from "../../../../../api/nfe";
import { getPaymentMethods } from "../../../../../api/payments";
import { searchNCM, searchCFOP } from "../../../../../api/products";
import { increaseMonths } from "../../../../../utils";
import { ActionButton, PillContainer } from "../../../NFSe/emit/components/styles";
import CurrencyInput from "react-currency-input";
import { _Input } from "../../../../../_components/Input";
import LoadingInput from "../../../../../_components/LoadingInput";
import { toast } from "react-toastify";

// Mesma constante do AddPayment/index.jsx — formas de pagamento que permitem parcelamento
var PAYMENT_METHODS_ALLOW_INVOICES = [
  "85b486e2-1cfb-4b09-ae36-6c53c93984a2",
  "2f903e2c-3f25-43aa-81e4-3a803f779a91",
  "66d2e0bb-cd7a-41b1-9422-f955b8aca0d2",
  "2ebd591a-224d-408c-84bc-67870ecee8ec",
  "a6dc5919-9240-49c3-ae79-f599598942c2"
];
var ANALYSIS_STEPS = [
  { text: "Analisando o conteúdo...", subtext: "Processando estrutura do arquivo" },
  { text: "Identificando produtos, quantidades e valores...", subtext: "Inteligência artificial em ação" },
  { text: "Extraindo destinatário, NCMs e CFOPs...", subtext: "Organizando CPF/CNPJ, itens e pagamentos" },
  { text: "Finalizando extração inteligente...", subtext: "Cruzando dados com cadastro fiscal da filial" }
];

var DROPZONE_BASE = {
  border: "2px dashed #D0D5DD",
  borderRadius: "10px",
  padding: "36px 24px",
  textAlign: "center",
  cursor: "pointer",
  backgroundColor: "#F9FAFB",
  transition: "all 0.2s"
};

var DROPZONE_ACTIVE = {
  border: "2px dashed #0088cc",
  backgroundColor: "#eff8ff"
};

export default function ImportProductWithAIModal(props) {
  var show = props.show;
  var onHide = props.onHide;
  var onApplyData = props.onApplyData;

  var fileState = useState(null);
  var file = fileState[0];
  var setFile = fileState[1];

  var fileBase64State = useState("");
  var fileBase64 = fileBase64State[0];
  var setFileBase64 = fileBase64State[1];

  var fileTypeState = useState("image");
  var fileType = fileTypeState[0];
  var setFileType = fileTypeState[1];

  var isDragActiveState = useState(false);
  var isDragActive = isDragActiveState[0];
  var setIsDragActive = isDragActiveState[1];

  var isAnalyzingState = useState(false);
  var isAnalyzing = isAnalyzingState[0];
  var setIsAnalyzing = isAnalyzingState[1];

  var isRegisteringRecipientState = useState(false);
  var isRegisteringRecipient = isRegisteringRecipientState[0];
  var setIsRegisteringRecipient = isRegisteringRecipientState[1];

  var isRegisteringProductsState = useState(false);
  var isRegisteringProducts = isRegisteringProductsState[0];
  var setIsRegisteringProducts = isRegisteringProductsState[1];

  var autoRegisterRecipientState = useState(true);
  var autoRegisterRecipient = autoRegisterRecipientState[0];
  var setAutoRegisterRecipient = autoRegisterRecipientState[1];

  var currentStepIdxState = useState(0);
  var currentStepIdx = currentStepIdxState[0];
  var setCurrentStepIdx = currentStepIdxState[1];

  var extractedResultState = useState(null);
  var extractedResult = extractedResultState[0];
  var setExtractedResult = extractedResultState[1];

  // Remover errorMessage daqui, usaremos toast
  // var errorMessageState = useState("");
  // var errorMessage = errorMessageState[0];
  // var setErrorMessage = errorMessageState[1];

  var inputTypeState = useState("file");
  var inputType = inputTypeState[0];
  var setInputType = inputTypeState[1];

  var textInputState = useState("");
  var textInput = textInputState[0];
  var setTextInput = textInputState[1];

  var isRecordingState = useState(false);
  var isRecording = isRecordingState[0];
  var setIsRecording = isRecordingState[1];

  var isTranscribingState = useState(false);
  var isTranscribing = isTranscribingState[0];
  var setIsTranscribing = isTranscribingState[1];

  var chatInputState = useState("");
  var chatInput = chatInputState[0];
  var setChatInput = chatInputState[1];

  var chatMessagesState = useState([]);
  var chatMessages = chatMessagesState[0];
  var setChatMessages = chatMessagesState[1];

  var isChatRecordingState = useState(false);
  var isChatRecording = isChatRecordingState[0];
  var setIsChatRecording = isChatRecordingState[1];

  var fileInputRef = useRef(null);
  var chatEndRef = useRef(null);

  var expandedItemsState = useState({});
  var expandedItems = expandedItemsState[0];
  var setExpandedItems = expandedItemsState[1];

  var paymentMethodsListState = useState([]);
  var paymentMethodsList = paymentMethodsListState[0];
  var setPaymentMethodsList = paymentMethodsListState[1];

  var paymentRowsState = useState([]);
  var paymentRows = paymentRowsState[0];
  var setPaymentRows = paymentRowsState[1];

  var paymentRowsInitializedState = useState(false);
  var paymentRowsInitialized = paymentRowsInitializedState[0];
  var setPaymentRowsInitialized = paymentRowsInitializedState[1];

  // "Pagamento em andamento" — espelha o estado de AddPayment (method + paid_value)
  // antes de clicar em "Adicionar pagamento" para confirmar na lista.
  var pendingPaymentState = useState({ payment_method: "", name: "", value: 0 });
  var pendingPayment = pendingPaymentState[0];
  var setPendingPayment = pendingPaymentState[1];

  // --- Estados de parcelamento (Invoices) — espelha Invoices/index.jsx ---
  // installments: quantidade de parcelas (1x a 12x)
  // startDate: data do primeiro vencimento (padrão: +1 mês)
  // installmentsEnabled: true quando a forma de pagamento permite parcelamento
  var installmentsState = useState(1);
  var installments = installmentsState[0];
  var setInstallments = installmentsState[1];

  var startDateState = useState(null);
  var startDate = startDateState[0];
  var setStartDate = startDateState[1];

  var installmentsEnabledState = useState(false);
  var installmentsEnabled = installmentsEnabledState[0];
  var setInstallmentsEnabled = installmentsEnabledState[1];

  // --- Estados de validação NCM/CFOP por item (igual ao ChangesItem) ---
  // itemNcmLoading / itemCfopLoading: { [idx]: bool } indica se está buscando na API
  // itemNcmError / itemCfopError: { [idx]: string } mensagem de erro
  var itemNcmLoadingState = useState({});
  var itemNcmLoading = itemNcmLoadingState[0];
  var setItemNcmLoading = itemNcmLoadingState[1];

  var itemCfopLoadingState = useState({});
  var itemCfopLoading = itemCfopLoadingState[0];
  var setItemCfopLoading = itemCfopLoadingState[1];

  var itemNcmErrorState = useState({});
  var itemNcmError = itemNcmErrorState[0];
  var setItemNcmError = itemNcmErrorState[1];

  var itemCfopErrorState = useState({});
  var itemCfopError = itemCfopErrorState[0];
  var setItemCfopError = itemCfopErrorState[1];

  function toggleItemExpand(idx) {
    setExpandedItems(function(prev) {
      var next = Object.assign({}, prev);
      next[idx] = !next[idx];
      return next;
    });
  }

  function updateItem(idx, field, value) {
    var newItems = items.map(function(it, i) {
      return i === idx ? Object.assign({}, it, field) : it;
    });
    setExtractedResult(Object.assign({}, extractedResult, { items: newItems }));
  }

  useEffect(function() {
    if (!show) {
      handleReset();
    }
  }, [show]);

  useEffect(function() {
    function handlePaste(e) {
      if (!show || isAnalyzing || extractedResult) return;
      var clipboardData = e.clipboardData || window.clipboardData;
      if (!clipboardData) return;
      var items = clipboardData.items;
      if (!items) return;

      for (var i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") !== -1) {
          var blob = items[i].getAsFile();
          if (blob) {
            processFile(blob);
            break;
          }
        }
      }
    }

    window.addEventListener("paste", handlePaste);
    return function() { window.removeEventListener("paste", handlePaste); };
  }, [show, isAnalyzing, extractedResult]);

  useEffect(function() {
    var interval = null;
    if (isAnalyzing) {
      setCurrentStepIdx(0);
      interval = setInterval(function() {
        setCurrentStepIdx(function(prev) {
          return prev < ANALYSIS_STEPS.length - 1 ? prev + 1 : prev;
        });
      }, 2500);
    }
    return function() {
      if (interval) clearInterval(interval);
    };
  }, [isAnalyzing]);

  // Carrega as formas de pagamento cadastradas (mesma lista usada no formulário
  // manual de pagamento da NF-e) para preencher o select do campo de pagamento.
  useEffect(function() {
    if (!show) return;
    getPaymentMethods()
      .then(function(resp) {
        var methods = Array.isArray(resp) ? resp : (resp && resp.results) || [];
        setPaymentMethodsList(methods);
      })
      .catch(function() {
        setPaymentMethodsList([]);
      });
  }, [show]);

   // Inicializa as linhas de pagamento assim que o documento é processado:
   // usa os pagamentos identificados/casados pela IA, ou (se nenhum foi
   // identificado) uma linha padrão com o valor total dos itens, para que o
   // campo de pagamento sempre apareça pronto para o usuário revisar/preencher.
   useEffect(function() {
     if (!extractedResult || paymentRowsInitialized) return;

     var extractedItems = extractedResult.items || [];
     var totalValue = parseFloat(extractedItems.reduce(function(acc, it) {
       var qty = parseFloat(it.quantity) || 1;
       var price = parseFloat(it.unit_price) || 0;
       return acc + (qty * price);
     }, 0).toFixed(2));

     var extractedPayments = extractedResult.payments || [];
     var rows = [];

     // Adiciona pagamentos identificados pela IA (mesmo sem payment_method, tenta resolver pelo nome)
     if (extractedPayments.length > 0) {
       var validPaymentsCount = 0;
       var totalKnownValue = 0;

       rows = extractedPayments.map(function(p) {
         var pVal = parseFloat(p.value) || 0;
         var methodId = p.payment_method || "";
         var methodName = p.name || "";
         // Tenta resolver o UUID do método de pagamento caso a IA forneça apenas o nome
         if (!methodId && methodName && paymentMethodsList.length > 0) {
            var match = paymentMethodsList.find(function(m) { return m.name.toLowerCase().includes(methodName.toLowerCase()); });
            if (match) {
                methodId = match.id;
                methodName = match.name;
            }
         }
         
         if (pVal > 0) {
           totalKnownValue += pVal;
         } else {
           validPaymentsCount++;
         }

         return {
           payment_method: methodId,
           name: methodName,
           value: pVal, // Pode ser 0 neste momento
         };
       });

       // Distribui o valor restante igualmente entre os pagamentos sem valor definido
       var remainingValueForDist = Math.max(0, totalValue - totalKnownValue);
       if (validPaymentsCount > 0) {
           var valuePerPayment = parseFloat((remainingValueForDist / validPaymentsCount).toFixed(2));
           var distributed = 0;
           var currentValidIdx = 0;
           
           rows = rows.map(function(r) {
               if (r.value === 0) {
                   currentValidIdx++;
                   if (currentValidIdx === validPaymentsCount) {
                       r.value = parseFloat((remainingValueForDist - distributed).toFixed(2));
                   } else {
                       r.value = valuePerPayment;
                       distributed += valuePerPayment;
                   }
               }
               return r;
           });
       }
     }

     setPaymentRows(rows);
     setPaymentRowsInitialized(true);

     var sumRows = rows.reduce(function(acc, r) { return acc + (parseFloat(r.value) || 0); }, 0);
     var remaining = Math.max(0, parseFloat((totalValue - sumRows).toFixed(2)));

     // Inicializa o pendingPayment para preencher apenas o valor que "falta"
     setPendingPayment(function(prev) {
         var defMethod = prev.payment_method;
         var defName = prev.name;
         if (!defMethod && paymentMethodsList.length > 0) {
             defMethod = paymentMethodsList[0].id;
             defName = paymentMethodsList[0].name;
         }
         return { payment_method: defMethod || "", name: defName || "", value: remaining };
     });
   }, [extractedResult, paymentRowsInitialized, paymentMethodsList]);

  // Quando a lista de formas de pagamento carrega, garante que o form tenha um padrão
  useEffect(function() {
    if (paymentMethodsList.length === 0) return;

    // Atualiza paymentRows caso a IA tenha inserido um pagamento sem UUID
    // antes da lista de métodos carregar
    setPaymentRows(function(prevRows) {
        var needsUpdate = false;
        var updated = prevRows.map(function(r) {
            if (r.payment_method) return r;
            needsUpdate = true;
            var match = null;
            if (r.name) {
                match = paymentMethodsList.find(function(m) { return m.name.toLowerCase().includes(r.name.toLowerCase()); });
            }
            if (!match) match = paymentMethodsList[0];
            return { ...r, payment_method: match.id, name: match.name };
        });
        return needsUpdate ? updated : prevRows;
    });

    // Atualiza também o pagamento pendente se não tiver método ainda
    setPendingPayment(function(prev) {
      if (prev.payment_method) return prev;
      return { ...prev, payment_method: paymentMethodsList[0].id, name: paymentMethodsList[0].name };
    });
  }, [paymentMethodsList]);

  // Confirma o pagamento pendente na lista — espelha AddPayment.addPayment()
  function addPaymentRow() {
    if (!pendingPayment.payment_method || !pendingPayment.value) return;
    setPaymentRows(function(prev) {
      return prev.concat([{
        payment_method: pendingPayment.payment_method,
        name: pendingPayment.name,
        value: pendingPayment.value,
      }]);
    });
    // Reseta o valor pendente para 0, mantendo a forma de pagamento selecionada
    setPendingPayment(function(prev) { return { ...prev, value: 0 }; });
  }

  function removePaymentRow(idx) {
    setPaymentRows(function(prev) { return prev.filter(function(_, i) { return i !== idx; }); });
  }

  function updatePendingMethod(methodId) {
    var method = paymentMethodsList.find(function(m) { return m.id === methodId; });
    var isInstallable = PAYMENT_METHODS_ALLOW_INVOICES.indexOf(methodId) !== -1;
    // Inicializa startDate com próximo mês quando uma forma parc. é selecionada
    if (isInstallable && !startDate) {
      var d = new Date();
      d.setMonth(d.getMonth() + 1);
      setStartDate(d);
    }
    setInstallmentsEnabled(isInstallable);
    setPendingPayment(function(prev) { return { ...prev, payment_method: methodId, name: method ? method.name : "" }; });
  }

  function updatePendingValue(_mask, floatValue) {
    setPendingPayment(function(prev) { return { ...prev, value: floatValue || 0 }; });
  }

  // --- Handlers de NCM/CFOP com validação de API (igual ao ChangesItem/index.jsx) ---
  function handleNcmChange(idx, code) {
    code = code.replace(/\D/g, "");
    var newItems = items.slice();
    newItems[idx] = Object.assign({}, newItems[idx], { ncm: code });
    setExtractedResult(Object.assign({}, extractedResult, { items: newItems }));
    setItemNcmError(function(prev) { return Object.assign({}, prev, { [idx]: "" }); });
    if (code.length === 8) {
      setItemNcmLoading(function(prev) { return Object.assign({}, prev, { [idx]: true }); });
      searchNCM({ code: code })
        .then(function(resp) {
          if (!resp || resp.length === 0) {
            setItemNcmError(function(prev) { return Object.assign({}, prev, { [idx]: "NCM Não localizado" }); });
          }
        })
        .catch(function() {})
        .finally(function() {
          setItemNcmLoading(function(prev) { return Object.assign({}, prev, { [idx]: false }); });
        });
    }
  }

  function handleCfopChange(idx, code) {
    code = code.replace(/\D/g, "");
    var newItems = items.slice();
    newItems[idx] = Object.assign({}, newItems[idx], { cfop: code });
    setExtractedResult(Object.assign({}, extractedResult, { items: newItems }));
    setItemCfopError(function(prev) { return Object.assign({}, prev, { [idx]: "" }); });
    if (code.length === 4) {
      setItemCfopLoading(function(prev) { return Object.assign({}, prev, { [idx]: true }); });
      searchCFOP({ code: code })
        .then(function(resp) {
          if (!resp || resp.length === 0) {
            setItemCfopError(function(prev) { return Object.assign({}, prev, { [idx]: "CFOP não localizado" }); });
          }
        })
        .catch(function() {})
        .finally(function() {
          setItemCfopLoading(function(prev) { return Object.assign({}, prev, { [idx]: false }); });
        });
    }
  }

  function handleToggleRecording() {
    if (isRecording) {
      setIsRecording(false);
      if (window._recognitionInstanceNFe) {
        window._recognitionInstanceNFe.stop();
      }
      if (window._mediaRecorderNFe && window._mediaRecorderNFe.state !== "inactive") {
        window._mediaRecorderNFe.stop();
      }
      return;
    }

    var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    
    if (!SpeechRecognition) {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        toast.error("Seu navegador não suporta gravação de áudio.");
        return;
      }
      
      navigator.mediaDevices.getUserMedia({ audio: true }).then(function(stream) {
        var mediaRecorder = new MediaRecorder(stream);
        window._mediaRecorderNFe = mediaRecorder;
        var audioChunks = [];
        
        mediaRecorder.addEventListener("dataavailable", function(event) {
          audioChunks.push(event.data);
        });
        
        mediaRecorder.addEventListener("stop", function() {
          var audioBlob = new Blob(audioChunks, { type: "audio/webm" });
          var reader = new FileReader();
          reader.readAsDataURL(audioBlob);
          reader.onloadend = function() {
            var base64data = reader.result;
            
            setIsTranscribing(true);
            
            var branch = getBranchOwner();
            aiTranscribeAudioNFe({ audio_base64: base64data }, { branch_owner: branch ? branch.id : null })
              .then(function(response) {
                var data = (response && response.data) ? response.data : response;
                var transcribed = data.text || "";
                
                setTextInput(function(prev) {
                  return prev + (prev ? " " : "") + transcribed + " ";
                });
              })
              .catch(function(err) {
                var errMsg = "Erro ao transcrever áudio no servidor.";
                if (err && err.response && err.response.data && err.response.data.error) {
                  errMsg = err.response.data.error;
                }
                toast.error(errMsg);
              })
              .finally(function() {
                setIsTranscribing(false);
              });
          };
          
          stream.getTracks().forEach(function(track) { track.stop(); });
        });
        
        mediaRecorder.start();
        setIsRecording(true);
    
      }).catch(function(err) {
        toast.error("Erro ao acessar microfone: " + err.message);
      });
      return;
    }

    var recognition = new SpeechRecognition();
    window._recognitionInstanceNFe = recognition;
    recognition.lang = 'pt-BR';
    recognition.interimResults = true;
    
    recognition.onstart = function() {
      setIsRecording(true);
  
    };
    
    recognition.onresult = function(event) {
      var finalTranscript = '';
      
      for (var i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          finalTranscript += event.results[i][0].transcript;
        }
      }
      
      if (finalTranscript) {
        setTextInput(function(prev) {
          return prev + (prev ? " " : "") + finalTranscript + " ";
        });
      }
    };
    
    recognition.onerror = function(event) {
      setIsRecording(false);
      if (event.error !== 'no-speech') {
        toast.error("Erro no microfone: verifique as permissões de áudio.");
      }
    };
    
    recognition.onend = function() {
      setIsRecording(false);
    };
    
    recognition.start();
  }

  function handleReset() {
    setFile(null);
    setFileBase64("");
    setFileType("image");
    setIsDragActive(false);
    setIsAnalyzing(false);
    setCurrentStepIdx(0);
    setExtractedResult(null);


    setTextInput("");
    setIsRecording(false);
    setIsTranscribing(false);
    if (window._recognitionInstanceNFe) {
      window._recognitionInstanceNFe.stop();
    }

    setPaymentRows([]);
    setPaymentRowsInitialized(false);
    setPendingPayment({ payment_method: "", name: "", value: 0 });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }

  function processFile(selectedFile) {
    if (!selectedFile) return;


    setTextInput("");

    try {
      var fileTypeStr = (selectedFile.type || "").toLowerCase();
      var fileNameStr = (selectedFile.name || "").toLowerCase();

      var isPdf = fileTypeStr === "application/pdf" || fileNameStr.indexOf(".pdf") !== -1;
      var isImage = fileTypeStr.indexOf("image/") === 0 || /\.(jpg|jpeg|png|webp)$/i.test(fileNameStr);
      var isXml = fileTypeStr === "text/xml" || fileTypeStr === "application/xml" || fileNameStr.indexOf(".xml") !== -1;

      if (!isPdf && !isImage && !isXml) {
        toast.error("Por favor, envie apenas arquivos em formato PDF, Imagem (PNG, JPG, WEBP) ou XML de NF-e.");
        return;
      }

      if (selectedFile.size > 4 * 1024 * 1024) {
        toast.error("O arquivo é muito grande. O tamanho máximo permitido é de 4MB.");
        return;
      }

      setFile(selectedFile);
      // XML é tratado como texto — envia text_content em vez de base64
      if (isXml) {
        setFileType("xml");
        var xmlReader = new FileReader();
        xmlReader.onload = function(e) {
          setFileBase64(e.target.result);
        };
        xmlReader.onerror = function() {
          toast.error("Não foi possível ler o arquivo XML. Tente novamente.");
        };
        xmlReader.readAsText(selectedFile);
        return;
      }
      setFileType(isPdf ? "pdf" : "image");

      var reader = new FileReader();
      reader.onload = function(e) {
        setFileBase64(e.target.result);
      };
      reader.onerror = function() {
        toast.error("Não foi possível ler o arquivo. Tente novamente.");
      };
      reader.readAsDataURL(selectedFile);
    } catch (err) {
      toast.error("Erro interno ao processar arquivo: " + err.message);
    }
  }

  function handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(true);
  }

  function handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
  }

  function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      processFile(e.dataTransfer.files[0]);
    }
  }

  function handleFileInputChange(e) {
    if (e.target.files && e.target.files.length > 0) {
      processFile(e.target.files[0]);
    }
  }

  function handleAnalyze() {
    if (!fileBase64 && !textInput.trim()) return;
    if (isAnalyzing) return;

    setIsAnalyzing(true);


    var branch_owner = getBranchOwner();
    var payload = {};
    if (fileBase64) {
        if (fileType === "xml") {
          // XML de NF-e: envia como text_content para o backend extrair os dados
          payload.text_content = fileBase64;
        } else {
          payload.file_base64 = fileBase64;
          payload.file_type = fileType;
          payload.file_name = file ? file.name : "documento";
        }
    } else {
        payload.text_content = textInput;
    }

    aiReadProduct(payload, { branch_owner: branch_owner ? branch_owner.id : null })
      .then(function(response) {
        var data = (response && response.data) ? response.data : response;
        if (data && data.success) {
          setExtractedResult(data);
        } else {
          var errMsg = (data && data.error) ? data.error : "Não foi possível extrair os dados do documento.";
          toast.error(errMsg);
        }
      })
      .catch(function(err) {
        var errMsg = "Ocorreu um erro ao comunicar com a inteligência artificial. Tente novamente.";
        if (err && err.response && err.response.data && err.response.data.error) {
          errMsg = err.response.data.error;
        } else if (err && err.message) {
          errMsg = err.message;
        }
        toast.error(errMsg);
      })
      .finally(function() {
        setIsAnalyzing(false);
      });
  }

  function buildFinalPayments() {
    // Se o usuário ainda não clicou "Adicionar pagamento", usa o pagamento pendente
    // (exatamente como AddPayment faz: paid_value + payment_method selecionado)
    var confirmed = paymentRows.filter(function(r) { return r.payment_method && parseFloat(r.value) > 0; });
    if (confirmed.length === 0 && pendingPayment.payment_method && parseFloat(pendingPayment.value) > 0) {
      // Se parcelamento está ativado, gera as parcelas com due_date via increaseMonths
      if (installmentsEnabled && installments > 1 && startDate) {
        return _buildInstallments(pendingPayment, parseFloat(pendingPayment.value), installments, startDate);
      }
      return [{
        payment_method: pendingPayment.payment_method,
        name: pendingPayment.name,
        value: parseFloat(pendingPayment.value) || 0,
      }];
    }
    // Se há pagamentos confirmados na lista, usa eles diretamente
    return confirmed.map(function(r) {
      return {
        payment_method: r.payment_method,
        name: r.name,
        value: parseFloat(r.value) || 0,
        due_date: r.due_date || null,
        status: 1,
      };
    });
  }

  // Gera parcelas com due_date — espelha usePaymentScheduler (Invoices/hooks/index.js)
  function _buildInstallments(paymentMethod, totalValue, numInstallments, firstDate) {
    var dates = increaseMonths(new Date(firstDate), numInstallments);
    var installmentValue = parseFloat((totalValue / numInstallments).toFixed(2));
    var diff = parseFloat((totalValue - (installmentValue * numInstallments)).toFixed(2));
    var result = dates.map(function(date) {
      return {
        payment_method: paymentMethod.payment_method,
        name: paymentMethod.name,
        due_date: date,
        value: installmentValue,
        status: 1,
      };
    });
    // A última parcela absorve a diferença dos centavos (exatamente como o hook manual)
    if (result.length > 0) {
      result[result.length - 1].value = parseFloat((result[result.length - 1].value + diff).toFixed(2));
    }
    return result;
  }

  function addInstallmentsToRows() {
    if (!installmentsEnabled || !pendingPayment.payment_method || !parseFloat(pendingPayment.value)) return;
    var invoices = _buildInstallments(pendingPayment, parseFloat(pendingPayment.value), installments, startDate || new Date());
    setPaymentRows(function(prev) { return prev.concat(invoices); });
    setPendingPayment(function(prev) { return { ...prev, value: 0 }; });
    setInstallments(1);
  }

  function registerMissingProducts(itemsList, branchId) {
    // Usa o endpoint batch ao invés de N requisições individuais (resolve o loop N+1)
    return aiRegisterProductsBatch({ items: itemsList, branch_owner: branchId }, {})
      .then(function(response) {
        var data = (response && response.data) ? response.data : response;
        return (data && Array.isArray(data.items)) ? data.items : itemsList;
      })
      .catch(function() {
        return itemsList;
      });
  }

  function handleConfirmApply(autoEmit) {
    if (!extractedResult) return;
    if (typeof autoEmit !== "boolean") {
      autoEmit = true;
    }

    var finalPayments = buildFinalPayments();
    var branch = getBranchOwner();
    var branchId = branch ? branch.id : null;
    var shouldRegisterRecipient = autoRegisterRecipient && !extractedResult.matched_recipient && extractedResult.recipient && branch && branch.id;


    setIsRegisteringProducts(true);

    registerMissingProducts(extractedResult.items || [], branchId)
      .then(function(itemsWithProducts) {
        setIsRegisteringProducts(false);

        var stillMissing = itemsWithProducts.filter(function(it) { return !it.original_id; });
        if (stillMissing.length > 0) {
          toast.error(
            "Não foi possível cadastrar automaticamente " + stillMissing.length +
            " produto(s) novo(s). Preencha as informações obrigatórias (como Preço de Venda) e tente novamente."
          );
          // Mantém os itens já resolvidos na tela, para não perder o que já deu certo
          setExtractedResult(Object.assign({}, extractedResult, { items: itemsWithProducts }));
          return;
        }

        var baseResult = Object.assign({}, extractedResult, { items: itemsWithProducts });

        if (shouldRegisterRecipient) {
          setIsRegisteringRecipient(true);
          setTextInput("");

          var payload = { recipient: baseResult.recipient };
          aiRegisterRecipient(payload, { branch_owner: branch.id })
            .then(function(response) {
              var data = (response && response.data) ? response.data : response;
              var updated = Object.assign({}, baseResult);
              if (data && data.recipient && data.recipient.original_id) {
                updated.recipient = Object.assign({}, updated.recipient, data.recipient);
                updated.matched_recipient = true;
              }
              updated.payments = finalPayments;
              if (onApplyData) {
                onApplyData(updated, { autoEmit: autoEmit });
              }
              onHide();
            })
            .catch(function(err) {
              var errMsg = "Falha ao cadastrar destinatário na base de dados.";
              if (err && err.response && err.response.data && err.response.data.error) {
                errMsg = err.response.data.error;
              } else if (err && err.message) {
                errMsg = err.message;
              }
              toast.error(errMsg);
            })
            .finally(function() {
              setIsRegisteringRecipient(false);
            });
        } else {
          var finalData = Object.assign({}, baseResult, { payments: finalPayments });
          if (onApplyData) {
            onApplyData(finalData, { autoEmit: autoEmit });
          }
          onHide();
        }
      })
      .catch(function(err) {
        setIsRegisteringProducts(false);
        var errMsg = "Falha ao cadastrar produto(s) novo(s) na base de dados.";
        if (err && err.response && err.response.data && err.response.data.error) {
          errMsg = err.response.data.error;
        } else if (err && err.message) {
          errMsg = err.message;
        }
        toast.error(errMsg);
      });
  }


  var isPdf = fileType === "pdf";
  var recipient = (extractedResult && extractedResult.recipient) ? extractedResult.recipient : {};
  var identification = (extractedResult && extractedResult.identification) ? extractedResult.identification : {};
  var items = (extractedResult && extractedResult.items) ? extractedResult.items : [];
  var fiscalAdjustments = (extractedResult && extractedResult.fiscal_adjustments) ? extractedResult.fiscal_adjustments : [];
  var branchOwnerData = getBranchOwner();
  var branchCrt = branchOwnerData ? branchOwnerData.crt : null;
  var itemsTotalValue = items.reduce(function(acc, it) {
    var qty = parseFloat(it.quantity) || 1;
    var price = parseFloat(it.unit_price) || 0;
    return acc + (qty * price);
  }, 0);
  var paymentsTotalValue = paymentRows.reduce(function(acc, r) { return acc + (parseFloat(r.value) || 0); }, 0);
  var paymentsMatchTotal = Math.abs(paymentsTotalValue - itemsTotalValue) < 0.01;

  var dropzoneStyle = Object.assign({}, DROPZONE_BASE, isDragActive ? DROPZONE_ACTIVE : {});
  var isMatchedRecipient = Boolean(extractedResult && extractedResult.matched_recipient);
  var canApply = Boolean(extractedResult && (isMatchedRecipient || autoRegisterRecipient));

  // Há pagamento válido se: alguma linha confirmada tem valor, OU o pagamento
  // pendente (ainda não clicado "Adicionar") tem método e valor — espelha
  // AddPayment onde o valor é válido antes de confirmar.
  var hasValidPayment = paymentRows.some(function(r) { return r.payment_method && parseFloat(r.value) > 0; })
    || Boolean(pendingPayment.payment_method && parseFloat(pendingPayment.value) > 0);
  var canEmitDirectly = canApply && hasValidPayment;
  var isBusyApplying = isRegisteringRecipient || isRegisteringProducts;

  return (
    <Modal show={show} onHide={(isAnalyzing || isBusyApplying) ? null : onHide} size="lg" centered backdrop={(isAnalyzing || isBusyApplying) ? "static" : true}>
      <Modal.Header closeButton={!isAnalyzing && !isBusyApplying} style={{ borderBottom: "1px solid #EAECF0", padding: "20px 24px" }}>
        <Modal.Title style={{ fontWeight: 700, color: "#101828", fontSize: "1.15rem", display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={{
            background: "linear-gradient(135deg, #0088cc 0%, #005580 100%)",
            width: "38px",
            height: "38px",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            flexShrink: 0,
            boxShadow: "0 4px 10px rgba(0, 136, 204, 0.3)",
            position: "relative",
            overflow: "hidden"
          }}>
            <style>
              {`
                @keyframes ai-icon-pulse-nfe {
                  0%, 100% { transform: scale(0.9); opacity: 0.85; }
                  50% { transform: scale(1.15); opacity: 1; }
                }
                @keyframes ai-icon-spin-nfe {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
            <div style={{
               position: "absolute",
               width: "200%", height: "200%",
               background: "conic-gradient(transparent, rgba(255,255,255,0.35), transparent 40%)",
               animation: "ai-icon-spin-nfe 3s linear infinite"
            }} />
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ zIndex: 1, animation: "ai-icon-pulse-nfe 2s ease-in-out infinite" }}>
              <path d="M11.64 5.23a.75.75 0 0 1 1.42 0l1.24 3.73a4 4 0 0 0 2.54 2.54l3.73 1.24a.75.75 0 0 1 0 1.42l-3.73 1.24a4 4 0 0 0-2.54 2.54l-1.24 3.73a.75.75 0 0 1-1.42 0l-1.24-3.73a4 4 0 0 0-2.54-2.54l-3.73-1.24a.75.75 0 0 1 0-1.42l3.73-1.24a4 4 0 0 0 2.54-2.54l1.24-3.73Z"/>
              <path d="M19.64 1.23a.5.5 0 0 1 .95 0l.5 1.5a2 2 0 0 0 1.27 1.27l1.5.5a.5.5 0 0 1 0 .95l-1.5.5a2 2 0 0 0-1.27 1.27l-.5 1.5a.5.5 0 0 1-.95 0l-.5-1.5a2 2 0 0 0-1.27-1.27l-1.5-.5a.5.5 0 0 1 0-.95l1.5-.5a2 2 0 0 0 1.27-1.27l.5-1.5Z"/>
            </svg>
          </div>
          Preenchimento Inteligente de NF-e com IA
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: "24px" }}>


        {isAnalyzing ? (
          <div style={{ padding: "32px 0", textAlign: "center" }}>
            <div style={{
              width: "120px",
              height: "140px",
              margin: "0 auto 24px auto",
              background: "#fff",
              border: "1px solid #EAECF0",
              borderRadius: "10px",
              padding: "14px 12px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              position: "relative",
              overflow: "hidden",
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)"
            }}>
              {[75, 90, 50, 60, 75, 50].map(function(w, idx) {
                return (
                  <div key={idx} style={{
                    height: "7px",
                    borderRadius: "4px",
                    background: "#F2F4F7",
                    width: w + "%"
                  }}></div>
                );
              })}
              <div style={{
                position: "absolute",
                left: 0,
                right: 0,
                height: "2px",
                background: "#0088cc",
                boxShadow: "0 0 10px 2px rgba(0,136,204,0.5)",
                animation: "nfe-scanner 2s ease-in-out infinite"
              }}></div>
            </div>
            <style>{"@keyframes nfe-scanner { 0% { top: 0%; } 50% { top: 95%; } 100% { top: 0%; } }"}</style>
            <strong style={{ display: "block", color: "#101828", fontSize: "1rem", marginBottom: "6px" }}>
              {ANALYSIS_STEPS[currentStepIdx].text}
            </strong>
            <span style={{ color: "#667085", fontSize: "0.875rem" }}>
              {ANALYSIS_STEPS[currentStepIdx].subtext}
            </span>
          </div>

        ) : extractedResult ? (
          <div>
            <div style={{
              background: "#ECFDF3",
              border: "1px solid #ABEFC6",
              borderRadius: "8px",
              padding: "14px 16px",
              marginBottom: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  background: "#17B26A",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                }}>
                  <i className="fas fa-check"></i>
                </div>
                <div>
                  <strong style={{ color: "#067647", fontSize: "0.95rem" }}>Documento Processado com Sucesso!</strong>
                  <br />
                  <span style={{ color: "#085D3A", fontSize: "0.82rem" }}>Revise os dados abaixo antes de preencher o formulário.</span>
                </div>
              </div>
              <span style={{
                background: isMatchedRecipient ? "#ECFDF3" : "#FEF3F2",
                color: isMatchedRecipient ? "#067647" : "#B42318",
                border: "1px solid " + (isMatchedRecipient ? "#ABEFC6" : "#FECDCA"),
                borderRadius: "20px",
                padding: "5px 14px",
                fontSize: "0.8rem",
                fontWeight: 700,
                whiteSpace: "nowrap",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px"
              }}>
                <i className={"fas fa-" + (isMatchedRecipient ? "user-check" : "user-xmark")} style={{ color: isMatchedRecipient ? "#17B26A" : "#D92D20" }}></i>
                {isMatchedRecipient ? "Destinatário Cadastrado" : "Destinatário Não Cadastrado"}
              </span>
            </div>

            {fiscalAdjustments.length > 0 && (
              <div style={{
                background: "#FFF8E6",
                border: "1px solid #FCE096",
                borderRadius: "8px",
                padding: "12px 16px",
                marginBottom: "20px",
                display: "flex",
                alignItems: "flex-start",
                gap: "10px"
              }}>
                <i className="fas fa-triangle-exclamation" style={{ color: "#B54708", marginTop: "2px" }}></i>
                <div style={{ color: "#7A4E0E", fontSize: "0.82rem", lineHeight: 1.5 }}>
                  <strong style={{ display: "block", marginBottom: "4px", color: "#93620C" }}>
                    Ajustes fiscais automáticos aplicados:
                  </strong>
                  <ul style={{ margin: 0, paddingLeft: "18px" }}>
                    {fiscalAdjustments.map(function(note, idx) {
                      return <li key={idx}>{note}</li>;
                    })}
                  </ul>
                </div>
              </div>
            )}

            {/* Destinatário */}
            <div style={{ background: "#fff", border: "1px solid #EAECF0", borderRadius: "10px", padding: "16px", marginBottom: "14px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px", paddingBottom: "10px", borderBottom: "1px solid #F2F4F7" }}>
                <strong style={{ color: "#101828", fontSize: "0.95rem" }}>
                  <i className="fas fa-truck-loading" style={{ color: "#0088cc", marginRight: "8px" }}></i>
                  Destinatário Identificado
                </strong>
                {recipient.cnpj_cpf && (
                  <span style={{ background: "#eff8ff", color: "#0088cc", border: "1px solid #b3d9f0", borderRadius: "20px", padding: "3px 10px", fontSize: "0.78rem", fontWeight: 600, display: "flex", alignItems: "center", gap: "4px" }}>
                    {recipient.cnpj_cpf.replace(/\D/g, '').length > 11 ? "CNPJ" : "CPF"}: 
                    <input type="text" value={recipient.cnpj_cpf || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {recipient: Object.assign({}, recipient, {cnpj_cpf: e.target.value})})); }} style={{ background: "transparent", border: "none", color: "#0088cc", fontWeight: 600, width: "120px", outline: "none" }} />
                  </span>
                )}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px" }}>
                <PillContainer>
                  <span className="label">Razão Social / Nome</span>
                  <input type="text" value={recipient.name || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {recipient: Object.assign({}, recipient, {name: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Não identificado" />
                </PillContainer>
                <PillContainer>
                  <span className="label">E-mail</span>
                  <input type="text" value={recipient.email || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {recipient: Object.assign({}, recipient, {email: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Email" />
                </PillContainer>
                <PillContainer>
                  <span className="label">Endereço</span>
                  <input type="text" value={recipient.address || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {recipient: Object.assign({}, recipient, {address: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Logradouro" />
                </PillContainer>
                <PillContainer>
                  <span className="label">Município</span>
                  <input type="text" value={recipient.city || ""} onChange={function(e){ setExtractedResult(Object.assign({}, extractedResult, {recipient: Object.assign({}, recipient, {city: e.target.value})})); }} style={{ width: "100%", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 8px", fontSize: "0.85rem", color: "#344054", outline: "none" }} placeholder="Cidade" />
                </PillContainer>
              </div>

              {!isMatchedRecipient && (
                <div style={{
                  background: "#FFF4ED",
                  border: "1.5px solid #FDCF8A",
                  borderRadius: "10px",
                  padding: "16px",
                  marginTop: "14px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px"
                }}>
                  <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                    <div style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "#FEF0C7",
                      color: "#B54708",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1rem",
                      flexShrink: 0,
                      marginTop: "2px"
                    }}>
                      <i className="fas fa-user-plus"></i>
                    </div>
                    <div style={{ flex: 1 }}>
                      <strong style={{ color: "#B54708", fontSize: "0.95rem", display: "block", marginBottom: "4px" }}>
                        Destinatário não localizado na base de clientes
                      </strong>
                      <p style={{ color: "#7A2E0E", fontSize: "0.85rem", margin: "0 0 12px 0", lineHeight: 1.45 }}>
                        Para emitir a nota fiscal, este destinatário precisa ser cadastrado no sistema. Marque a opção abaixo para permitir o cadastro automático.
                      </p>
                      <label style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        margin: 0,
                        cursor: "pointer",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                        color: "#101828",
                        background: "#ffffff",
                        padding: "10px 14px",
                        borderRadius: "8px",
                        border: "1.5px solid " + (autoRegisterRecipient ? "#0088cc" : "#D0D5DD"),
                        boxShadow: autoRegisterRecipient ? "0 0 0 3px rgba(0, 136, 204, 0.15)" : "none",
                        transition: "all 0.2s"
                      }}>
                        <input
                          type="checkbox"
                          checked={autoRegisterRecipient}
                          onChange={function(e) { setAutoRegisterRecipient(e.target.checked); }}
                          style={{ width: "18px", height: "18px", accentColor: "#0088cc", cursor: "pointer" }}
                        />
                        <span>Quero cadastrar este destinatário como cliente na base de dados</span>
                      </label>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Identificação & Itens */}
            <div style={{ background: "#fff", border: "1px solid #EAECF0", borderRadius: "10px", padding: "16px", marginBottom: "14px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px", paddingBottom: "10px", borderBottom: "1px solid #F2F4F7", flexWrap: "wrap", gap: "8px" }}>
                <strong style={{ color: "#101828", fontSize: "0.95rem" }}>
                   <i className="fas fa-boxes" style={{ color: "#0088cc", marginRight: "8px" }}></i>
                   Produtos e Itens ({items.length})
                 </strong>
                 <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                   {items.some(function(it) { return it.matched_product; }) && (
                     <span style={{ background: "#ECFDF3", color: "#067647", border: "1px solid #ABEFC6", borderRadius: "20px", padding: "3px 10px", fontSize: "0.78rem", fontWeight: 600, display: "flex", alignItems: "center", gap: "4px" }}>
                       <i className="fas fa-box-check"></i> {items.filter(function(it) { return it.matched_product; }).length} produto(s) encontrado(s) no cadastro
                     </span>
                   )}
                   <span style={{ background: "#F2F4F7", color: "#344054", border: "1px solid #EAECF0", borderRadius: "20px", padding: "3px 12px", fontSize: "0.82rem", fontWeight: 600, display: "flex", alignItems: "center", gap: "4px" }}>
                     Nat. Op: {identification.nat_op || "Venda de mercadoria"}
                   </span>
                 </div>
              </div>
              
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", minWidth: "600px", borderCollapse: "separate", borderSpacing: "0 8px", fontSize: "0.85rem" }}>
                  <thead>
                    <tr style={{ background: "#F9FAFB", borderBottom: "1px solid #EAECF0" }}>
                      <th style={{ padding: "12px 8px", textAlign: "left", color: "#667085", fontWeight: 600, width: "40px" }}>#</th>
                      <th style={{ padding: "12px 8px", textAlign: "left", color: "#667085", fontWeight: 600 }}>Descrição</th>
                      <th style={{ padding: "12px 8px", textAlign: "left", color: "#667085", fontWeight: 600, width: "100px" }}>NCM</th>
                      <th style={{ padding: "12px 8px", textAlign: "left", color: "#667085", fontWeight: 600, width: "80px" }}>CFOP</th>
                      <th style={{ padding: "12px 8px", textAlign: "right", color: "#667085", fontWeight: 600, width: "70px" }}>Qtd</th>
                      <th style={{ padding: "12px 8px", textAlign: "right", color: "#667085", fontWeight: 600, width: "100px" }}>V. Unit</th>
                      <th style={{ padding: "12px 8px", textAlign: "right", color: "#667085", fontWeight: 600, width: "120px" }}>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map(function(item, idx) {
                      var isExpanded = Boolean(expandedItems[idx]);
                      return (
                        <React.Fragment key={idx}>
                          <tr style={{ background: isExpanded ? "#F9FAFB" : "#fff", border: "1px solid #EAECF0", boxShadow: "0 1px 2px rgba(16, 24, 40, 0.05)" }}>
                            <td style={{ padding: "12px 8px", borderTopLeftRadius: "8px", borderBottomLeftRadius: isExpanded ? "0" : "8px", borderTop: "1px solid #EAECF0", borderBottom: isExpanded ? "none" : "1px solid #EAECF0", borderLeft: "1px solid #EAECF0", color: "#98A2B3", fontWeight: 600 }}>
                              {idx + 1}
                            </td>
                            <td style={{ padding: "12px 8px", borderTop: "1px solid #EAECF0", borderBottom: isExpanded ? "none" : "1px solid #EAECF0" }}>
                               <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
                                 <input type="text" value={item.description || ""} onChange={function(e){
                                   var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { description: e.target.value });
                                   setExtractedResult(Object.assign({}, extractedResult, { items: newItems }));
                                 }} style={{ width: "100%", border: "1px solid transparent", background: "transparent", outline: "none", fontWeight: 500 }} />
                                 {item.matched_product && (
                                   <span style={{ fontSize: "0.72rem", color: "#067647", fontWeight: 600, display: "flex", alignItems: "center", gap: "4px" }}>
                                     <i className="fas fa-check-circle"></i> Produto cadastrado
                                   </span>
                                 )}
                               </div>
                             </td>
                            <td style={{ padding: "12px 8px", borderTop: "1px solid #EAECF0", borderBottom: isExpanded ? "none" : "1px solid #EAECF0" }}>{item.ncm}</td>
                             <td style={{ padding: "12px 8px", borderTop: "1px solid #EAECF0", borderBottom: isExpanded ? "none" : "1px solid #EAECF0" }}>
                               {item.cfop}
                               {item.cfop_auto_corrected && (
                                 <i className="fas fa-wand-magic-sparkles" title="CFOP ajustado automaticamente para a operação (UF/entrada-saída)" style={{ color: "#B54708", marginLeft: "6px", fontSize: "0.8rem" }}></i>
                               )}
                             </td>
                            <td style={{ padding: "12px 8px", textAlign: "right", borderTop: "1px solid #EAECF0", borderBottom: isExpanded ? "none" : "1px solid #EAECF0" }}>
                              <CurrencyInput
                                style={{ width: "60px", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 6px", textAlign: "right", outline: "none", fontSize: "0.85rem" }}
                                decimalSeparator=","
                                thousandSeparator="."
                                precision="2"
                                value={item.quantity || 0}
                                onChange={function(mask, floatValue) {
                                  var newItems = items.slice();
                                  var qty = floatValue || 0;
                                  var price = parseFloat(newItems[idx].unit_price) || 0;
                                  newItems[idx] = Object.assign({}, newItems[idx], { quantity: qty, total: price * qty });
                                  setExtractedResult(Object.assign({}, extractedResult, { items: newItems }));
                                }}
                              />
                            </td>
                            <td style={{ padding: "12px 8px", textAlign: "right", borderTop: "1px solid #EAECF0", borderBottom: isExpanded ? "none" : "1px solid #EAECF0" }}>
                              <CurrencyInput
                                style={{ width: "80px", border: "1px solid #EAECF0", borderRadius: "4px", padding: "4px 6px", textAlign: "right", outline: "none", fontSize: "0.85rem" }}
                                decimalSeparator=","
                                thousandSeparator="."
                                precision="2"
                                prefix="R$ "
                                value={item.unit_price || 0}
                                onChange={function(mask, floatValue) {
                                  var newItems = items.slice();
                                  var price = floatValue || 0;
                                  var qty = parseFloat(newItems[idx].quantity) || 0;
                                  newItems[idx] = Object.assign({}, newItems[idx], { unit_price: price, total: price * qty });
                                  setExtractedResult(Object.assign({}, extractedResult, { items: newItems }));
                                }}
                              />
                            </td>
                            <td style={{ padding: "12px 8px", textAlign: "right", fontWeight: 600, color: "#067647", borderTopRightRadius: "8px", borderBottomRightRadius: isExpanded ? "0" : "8px", borderTop: "1px solid #EAECF0", borderBottom: isExpanded ? "none" : "1px solid #EAECF0", borderRight: "1px solid #EAECF0" }}>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "8px" }}>
                                R$ {parseFloat(item.total || 0).toFixed(2)}
                                <button
                                  type="button"
                                  onClick={function() { toggleItemExpand(idx); }}
                                  style={{ background: isExpanded ? "#eff8ff" : "#F2F4F7", border: "1px solid " + (isExpanded ? "#b3d9f0" : "#EAECF0"), color: isExpanded ? "#0088cc" : "#667085", borderRadius: "6px", width: "26px", height: "26px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: "0.85rem", transition: "all 0.15s" }}
                                  title="Ver / editar detalhes fiscais"
                                >
                                  <i className={"fas fa-chevron-" + (isExpanded ? "up" : "down")}></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                          {isExpanded && (
                            <tr>
                              <td colSpan="7" style={{ padding: "16px", background: "#F9FAFB", borderBottom: "1px solid #EAECF0", borderLeft: "1px solid #EAECF0", borderRight: "1px solid #EAECF0", borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: "12px" }}>
                                   {/* ICMS */}
                                   <div>
                                     <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>
                                       ICMS {(branchCrt === 3 || branchCrt === 2) ? "CST" : "CSOSN"}
                                     </span>
                                     {(branchCrt === 3 || branchCrt === 2) ? (
                                       <LoadingInput value={(item.icms && item.icms.cst) || ""} maxLength={2} onChange={function(e){ var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { icms: Object.assign({}, newItems[idx].icms, { cst: e.target.value }) }); setExtractedResult(Object.assign({}, extractedResult, { items: newItems })); }} placeholder="00" />
                                     ) : (
                                       <LoadingInput value={(item.icms && item.icms.csosn) || ""} maxLength={3} onChange={function(e){ var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { icms: Object.assign({}, newItems[idx].icms, { csosn: e.target.value }) }); setExtractedResult(Object.assign({}, extractedResult, { items: newItems })); }} placeholder="102" />
                                     )}
                                   </div>
                                   <div style={{ position: "relative" }}>
                                     <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>ICMS % Alíquota</span>
                                     <CurrencyInput
                                       className="form-control"
                                       decimalSeparator=","
                                       thousandSeparator="."
                                       precision="2"
                                       value={(item.icms && item.icms.p_icms) || 0}
                                       onChange={function(mask, floatValue) { var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { icms: Object.assign({}, newItems[idx].icms, { p_icms: floatValue || 0 }) }); setExtractedResult(Object.assign({}, extractedResult, { items: newItems })); }}
                                     />
                                     <span style={{ position: "absolute", right: "10px", top: "34px", fontSize: "0.8rem", fontWeight: 600, color: "#667085", pointerEvents: "none" }}>%</span>
                                   </div>
                                   {/* IPI */}
                                   <div>
                                     <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>IPI CST</span>
                                     <LoadingInput value={(item.ipi && item.ipi.cst) || ""} maxLength={2} onChange={function(e){ var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { ipi: Object.assign({}, newItems[idx].ipi, { cst: e.target.value }) }); setExtractedResult(Object.assign({}, extractedResult, { items: newItems })); }} placeholder="99" />
                                   </div>
                                   <div style={{ position: "relative" }}>
                                     <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>IPI % Alíquota</span>
                                     <CurrencyInput
                                       className="form-control"
                                       decimalSeparator=","
                                       thousandSeparator="."
                                       precision="2"
                                       value={(item.ipi && item.ipi.p_ipi) || 0}
                                       onChange={function(mask, floatValue) { var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { ipi: Object.assign({}, newItems[idx].ipi, { p_ipi: floatValue || 0 }) }); setExtractedResult(Object.assign({}, extractedResult, { items: newItems })); }}
                                     />
                                     <span style={{ position: "absolute", right: "10px", top: "34px", fontSize: "0.8rem", fontWeight: 600, color: "#667085", pointerEvents: "none" }}>%</span>
                                   </div>
                                   {/* PIS */}
                                   <div>
                                     <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>PIS CST</span>
                                     <LoadingInput value={(item.pis && item.pis.cst) || ""} maxLength={2} onChange={function(e){ var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { pis: Object.assign({}, newItems[idx].pis, { cst: e.target.value }) }); setExtractedResult(Object.assign({}, extractedResult, { items: newItems })); }} placeholder="99" />
                                  </div>
                                   <div style={{ position: "relative" }}>
                                     <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>PIS % Alíquota</span>
                                     <CurrencyInput
                                       className="form-control"
                                       decimalSeparator=","
                                       thousandSeparator="."
                                       precision="2"
                                       value={(item.pis && item.pis.p_pis) || 0}
                                       onChange={function(mask, floatValue) { var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { pis: Object.assign({}, newItems[idx].pis, { p_pis: floatValue || 0 }) }); setExtractedResult(Object.assign({}, extractedResult, { items: newItems })); }}
                                     />
                                     <span style={{ position: "absolute", right: "10px", top: "34px", fontSize: "0.8rem", fontWeight: 600, color: "#667085", pointerEvents: "none" }}>%</span>
                                   </div>
                                   {/* COFINS */}
                                   <div>
                                     <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>COFINS CST</span>
                                     <LoadingInput value={(item.cofins && item.cofins.cst) || ""} maxLength={2} onChange={function(e){ var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { cofins: Object.assign({}, newItems[idx].cofins, { cst: e.target.value }) }); setExtractedResult(Object.assign({}, extractedResult, { items: newItems })); }} placeholder="99" />
                                   </div>
                                   <div style={{ position: "relative" }}>
                                     <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>COFINS % Alíquota</span>
                                     <CurrencyInput
                                       className="form-control"
                                       decimalSeparator=","
                                       thousandSeparator="."
                                       precision="2"
                                       value={(item.cofins && item.cofins.p_cofins) || 0}
                                       onChange={function(mask, floatValue) { var newItems = items.slice(); newItems[idx] = Object.assign({}, newItems[idx], { cofins: Object.assign({}, newItems[idx].cofins, { p_cofins: floatValue || 0 }) }); setExtractedResult(Object.assign({}, extractedResult, { items: newItems })); }}
                                     />
                                     <span style={{ position: "absolute", right: "10px", top: "34px", fontSize: "0.8rem", fontWeight: 600, color: "#667085", pointerEvents: "none" }}>%</span>
                                   </div>
                                    {/* NCM / CFOP — LoadingInput com validação de API igual ao ChangesItem */}
                                    <div>
                                      <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>NCM</span>
                                      <LoadingInput
                                        value={item.ncm || ""}
                                        maxLength={8}
                                        name={"ncm-" + idx}
                                        loading={!!itemNcmLoading[idx]}
                                        onChange={function(e){ handleNcmChange(idx, e.target.value); }}
                                        placeholder="00000000"
                                      />
                                      {itemNcmError[idx] && (
                                        <span style={{ fontSize: "0.72rem", color: "#D92D20", display: "block", marginTop: "2px" }}>{itemNcmError[idx]}</span>
                                      )}
                                    </div>
                                    <div>
                                      <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#667085", textTransform: "uppercase", display: "block", marginBottom: "4px" }}>CFOP</span>
                                      <LoadingInput
                                        value={item.cfop || ""}
                                        maxLength={4}
                                        name={"cfop-" + idx}
                                        loading={!!itemCfopLoading[idx]}
                                        onChange={function(e){ handleCfopChange(idx, e.target.value); }}
                                        placeholder="5102"
                                      />
                                      {itemCfopError[idx] && (
                                        <span style={{ fontSize: "0.72rem", color: "#D92D20", display: "block", marginTop: "2px" }}>{itemCfopError[idx]}</span>
                                      )}
                                    </div>
                                    {!item.matched_product && (
                                      <span style={{ fontSize: "0.72rem", color: "#B54708", background: "#FEF0C7", padding: "2px 6px", borderRadius: "4px", fontWeight: 600, display: "flex", alignItems: "center", gap: "4px", marginTop: "4px", width: "fit-content" }}>
                                        <i className="fas fa-plus-circle"></i> Novo produto (será cadastrado)
                                      </span>
                                    )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                    {items.length === 0 && (
                      <tr><td colSpan="7" style={{ padding: "20px", textAlign: "center", color: "#667085", background: "#fff", border: "1px solid #EAECF0", borderRadius: "8px" }}>Nenhum item detectado.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Pagamento — espelha AddPayment exatamente */}
            <div style={{ background: "#fff", border: "1px solid #EAECF0", borderRadius: "10px", padding: "16px", marginBottom: "14px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px", paddingBottom: "10px", borderBottom: "1px solid #F2F4F7", flexWrap: "wrap", gap: "8px" }}>
                <strong style={{ color: "#101828", fontSize: "0.95rem" }}>
                  <i className="fas fa-money-bill-wave" style={{ color: "#0088cc", marginRight: "8px" }}></i>
                  Pagamento
                </strong>
                <span style={{
                  background: paymentsMatchTotal ? "#ECFDF3" : "#FFF8E6",
                  color: paymentsMatchTotal ? "#067647" : "#B54708",
                  border: "1px solid " + (paymentsMatchTotal ? "#ABEFC6" : "#FCE096"),
                  borderRadius: "20px", padding: "3px 12px", fontSize: "0.78rem", fontWeight: 600
                }}>
                  Itens: R$ {itemsTotalValue.toFixed(2)} &nbsp;·&nbsp; Pagamentos: R$ {paymentsTotalValue.toFixed(2)}
                </span>
              </div>

              {/* Lista de pagamentos confirmados */}
              {paymentRows.map(function(row, idx) {
                return (
                  <div key={idx} style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "6px", background: "#F9FAFB", padding: "8px 12px", borderRadius: "6px", border: "1px solid #EAECF0" }}>
                    <span style={{ flex: 1, fontSize: "0.85rem", color: "#344054" }}>{row.name || row.payment_method}</span>
                    <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "#101828" }}>R$ {parseFloat(row.value).toFixed(2)}</span>
                    <button type="button" onClick={function() { removePaymentRow(idx); }} style={{ background: "#FEF3F2", border: "1px solid #FECDCA", color: "#D92D20", borderRadius: "6px", width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                      <i className="fas fa-trash-alt" style={{ fontSize: "0.75rem" }}></i>
                    </button>
                  </div>
                );
              })}

              {/* Pagamento pendente — _Input idêntico ao AddPayment */}
              <div className="row">
                <div className="col-md-6 col-xs-12">
                  <_Input
                    disabled={paymentMethodsList.length === 0}
                    onChange={function(e) { updatePendingMethod(e.value); }}
                    value={pendingPayment.payment_method}
                    type="select"
                    options={paymentMethodsList.map(function(p) { return { label: p.name, value: p.id }; })}
                  />
                </div>
                <div className="col-md-6 col-xs-12">
                  <_Input
                    type="currency"
                    disabled={paymentMethodsList.length === 0}
                    onChange={function(e) { updatePendingValue(null, e.value); }}
                    value={pendingPayment.value}
                  />
                </div>
              </div>

              {/* Parcelamento — aparece quando a forma de pagamento permite (espelha Invoices/index.jsx) */}
              {installmentsEnabled && (
                <div style={{ background: "#F9FAFB", border: "1px solid #EAECF0", borderRadius: "8px", padding: "12px 14px", marginBottom: "10px", marginTop: "4px" }}>
                  <strong style={{ fontSize: "0.85rem", color: "#344054", display: "block", marginBottom: "10px" }}>
                    <i className="fas fa-calendar-alt" style={{ color: "#0088cc", marginRight: "6px" }}></i>
                    Parcelamento
                  </strong>
                  <div className="row">
                    <div className="col-md-6 col-xs-12">
                      <span style={{ fontSize: "0.78rem", fontWeight: 600, color: "#667085", display: "block", marginBottom: "4px" }}>Primeiro Vencimento</span>
                      <_Input
                        name="startDate"
                        onChange={function(e) { setStartDate(e.value); }}
                        type="date"
                        value={startDate}
                      />
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <span style={{ fontSize: "0.78rem", fontWeight: 600, color: "#667085", display: "block", marginBottom: "4px" }}>
                        Parcelas: {installments}x de R$ {pendingPayment.value > 0 ? (pendingPayment.value / installments).toFixed(2) : "0,00"}
                      </span>
                      <_Input
                        type="number"
                        onChange={function(e) { setInstallments(Math.max(1, parseInt(e.value) || 1)); }}
                        min={1}
                        value={installments}
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!pendingPayment.payment_method || !pendingPayment.value || itemsTotalValue <= paymentsTotalValue + 0.01}
                    onClick={addInstallmentsToRows}
                    style={{ marginTop: "10px" }}
                  >
                    <i className="fas fa-layer-group" style={{ marginRight: "6px" }}></i>
                    Adicionar Parcelas
                  </button>
                </div>
              )}

              <div className="row">
                <div className="col-md-6 col-xs-12">
                  {!installmentsEnabled && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={!pendingPayment.payment_method || !pendingPayment.value || itemsTotalValue <= paymentsTotalValue + 0.01}
                      onClick={addPaymentRow}
                      style={{ marginBottom: "8px" }}
                    >
                      Adicionar pagamento
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Chat de ajustes (Desativado temporariamente)
            <div style={{ background: "#F9FAFB", border: "1px solid #EAECF0", borderRadius: "10px", padding: "14px 16px", marginBottom: "4px" }}>
              ... 
            </div>
            */}
            
          </div>

        ) : (
          <div
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            style={{ 
              display: "flex", flexDirection: "column", height: "320px", 
              justifyContent: "space-between", position: "relative",
              border: isDragActive ? "2px dashed #0088cc" : "2px dashed transparent",
              backgroundColor: isDragActive ? "#eff8ff" : "transparent",
              borderRadius: "12px", transition: "all 0.2s"
            }}
          >
            {isDragActive && (
              <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(239, 248, 255, 0.9)", zIndex: 10, borderRadius: "10px" }}>
                <strong style={{ color: "#0088cc", fontSize: "1.2rem" }}><i className="fas fa-cloud-arrow-up"></i> Solte o arquivo aqui</strong>
              </div>
            )}

            <div style={{ flex: 1, overflowY: "auto", padding: "10px 4px", display: "flex", flexDirection: "column", gap: "12px" }}>
              {!file && !textInput && !isTranscribing && (
                <div style={{ alignSelf: "flex-start", background: "#F2F4F7", padding: "14px 18px", borderRadius: "16px", borderBottomLeftRadius: "4px", maxWidth: "90%", color: "#344054", fontSize: "0.95rem" }}>
                  <p style={{ margin: "0 0 8px 0" }}>Olá! Eu sou a <strong>Inteligência Artificial do Easygestor</strong>.</p>
                  <p style={{ margin: 0 }}>Envie um <strong>DANFE</strong>, <strong>XML de NF-e</strong> ou uma <strong>foto de nota fiscal</strong>. Você também pode digitar ou falar os dados da venda. Preencherei a NF-e para você automaticamente.</p>
                </div>
              )}

              {file && (
                <div style={{ alignSelf: "flex-end", background: "#eff8ff", padding: "12px 16px", borderRadius: "16px", borderBottomRightRadius: "4px", maxWidth: "85%", border: "1px solid #b3d9f0" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <i className={"fas fa-" + (isPdf ? "file-pdf" : "file-image")} style={{ fontSize: "1.8rem", color: isPdf ? "#D92D20" : "#0088cc" }}></i>
                    <div>
                      <strong style={{ display: "block", fontSize: "0.95rem", color: "#101828", wordBreak: "break-all" }}>{file.name}</strong>
                      <span style={{ fontSize: "0.8rem", color: "#667085" }}>{(file.size / (1024 * 1024)).toFixed(2)} MB</span>
                    </div>
                    <button type="button" onClick={handleReset} style={{ background: "transparent", border: "none", color: "#98A2B3", cursor: "pointer", marginLeft: "10px", padding: "4px" }}>
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              )}

              {isTranscribing && (
                <div style={{ alignSelf: "flex-end", background: "#F9FAFB", padding: "12px 16px", borderRadius: "16px", borderBottomRightRadius: "4px", maxWidth: "85%", color: "#667085", fontSize: "0.95rem", fontStyle: "italic" }}>
                  <i className="fas fa-spinner fa-spin" style={{ marginRight: "8px" }}></i> Transcrevendo áudio...
                </div>
              )}
            </div>

            {/* Input Bar */}
            <div style={{
              display: "flex", alignItems: "center",
              background: "#F9FAFB", border: "1px solid #EAECF0",
              borderRadius: "32px", padding: "8px 12px", gap: "8px",
              boxShadow: "0 2px 6px rgba(16, 24, 40, 0.05)"
            }}>
              <input
                type="file" ref={fileInputRef} onChange={handleFileInputChange}
                accept="application/pdf,image/png,image/jpeg,image/jpg,image/webp,text/xml,application/xml,.xml"
                style={{ display: "none" }}
              />
              <button 
                type="button"
                onClick={function() { if (fileInputRef.current) fileInputRef.current.click(); }}
                disabled={Boolean(file)}
                style={{ 
                  background: "transparent", border: "none", color: file ? "#D0D5DD" : "#667085", 
                  fontSize: "1.2rem", cursor: file ? "not-allowed" : "pointer", 
                  width: "36px", height: "36px", borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}
                title="Anexar arquivo"
              >
                <i className="fas fa-plus"></i>
              </button>

              <input 
                type="text" 
                value={textInput}
                onChange={function(e) { setTextInput(e.target.value); }}
                placeholder={isRecording ? "Ouvindo sua voz..." : file ? "Arquivo anexado. Clique em Enviar para analisar." : "Descreva a venda, cole uma imagem..."}
                disabled={isRecording || isTranscribing || Boolean(file)}
                style={{
                  flex: 1, background: "transparent", border: "none", outline: "none",
                  fontSize: "0.95rem", color: "#101828", minWidth: 0
                }}
                onKeyDown={function(e) {
                  if (e.key === 'Enter' && (file || textInput.trim()) && !isAnalyzing && !isRecording && !isTranscribing) {
                    handleAnalyze();
                  }
                }}
              />

              {!textInput.trim() && !file ? (
                <button 
                  type="button"
                  onClick={handleToggleRecording}
                  disabled={isTranscribing}
                  style={{ 
                    background: isRecording ? "#FEF3F2" : "transparent", 
                    border: "none", color: isRecording ? "#D92D20" : "#667085", 
                    fontSize: "1.1rem", cursor: isTranscribing ? "not-allowed" : "pointer",
                    width: "36px", height: "36px", borderRadius: "50%",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    transition: "all 0.2s"
                  }}
                  title="Ditar com voz"
                >
                  <i className={"fas fa-microphone" + (isRecording ? " fa-fade" : "")}></i>
                </button>
              ) : null}

              <button
                type="button"
                onClick={handleAnalyze}
                disabled={(!file && !textInput.trim()) || isAnalyzing || isRecording || isTranscribing}
                style={{
                  background: (!file && !textInput.trim()) || isRecording || isTranscribing ? "#F2F4F7" : "#0088cc",
                  border: "none", color: (!file && !textInput.trim()) || isRecording || isTranscribing ? "#98A2B3" : "#fff",
                  width: "36px", height: "36px", borderRadius: "50%",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  cursor: (!file && !textInput.trim()) || isRecording || isTranscribing ? "not-allowed" : "pointer",
                  transition: "all 0.2s"
                }}
                title="Enviar para análise"
              >
                <i className="fas fa-paper-plane" style={{ fontSize: "0.95rem", marginLeft: "-2px" }}></i>
              </button>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "1px solid #EAECF0", padding: "16px 24px", justifyContent: "space-between" }}>
        <ActionButton variant="secondary" onClick={onHide} disabled={isAnalyzing || isBusyApplying}>
          Cancelar
        </ActionButton>

        {extractedResult ? (
          <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap", justifyContent: "flex-end" }}>
            {!canApply && (
              <span style={{
                color: "#B42318",
                fontSize: "0.82rem",
                fontWeight: 600,
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                background: "#FEF3F2",
                padding: "6px 12px",
                borderRadius: "6px",
                border: "1px solid #FECDCA"
              }}>
                <i className="fas fa-circle-exclamation"></i>
                Marque o cadastro do destinatário para prosseguir
              </span>
            )}
            {canApply && !hasValidPayment && (
              <span style={{
                color: "#B54708",
                fontSize: "0.82rem",
                fontWeight: 600,
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                background: "#FFF8E6",
                padding: "6px 12px",
                borderRadius: "6px",
                border: "1px solid #FCE096"
              }}>
                <i className="fas fa-circle-exclamation"></i>
                Informe a forma de pagamento para emitir diretamente
              </span>
            )}
            <ActionButton variant="secondary" onClick={handleReset} disabled={isBusyApplying}>
              <i className="fas fa-rotate-left"></i>
              Analisar Outro
            </ActionButton>
            <ActionButton variant="secondary" onClick={function() { handleConfirmApply(false); }} disabled={!canApply || isBusyApplying} title="Preencher os campos do formulário para revisão manual antes de emitir">
              {isBusyApplying ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-file-pen"></i>}
              {isRegisteringProducts ? "Cadastrando produtos..." : isRegisteringRecipient ? "Cadastrando destinatário..." : "Preencher Formulário"}
            </ActionButton>
            <ActionButton variant="primary" onClick={function() { handleConfirmApply(true); }} disabled={!canEmitDirectly || isBusyApplying} title="Emitir NF-e diretamente com os dados extraídos">
              {isBusyApplying ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-bolt"></i>}
              {isRegisteringProducts ? "Cadastrando produtos..." : isRegisteringRecipient ? "Aguarde..." : "Emitir NF-e"}
            </ActionButton>
          </div>
        ) : (
          <ActionButton variant="primary" onClick={handleAnalyze} disabled={(!fileBase64 && !textInput.trim()) || isAnalyzing}>
            <i className={"fas fa-" + (isAnalyzing ? "circle-notch fa-spin" : "sparkles")}></i>
            {isAnalyzing ? "Analisando com IA..." : "Analisar com IA"}
          </ActionButton>
        )}
      </Modal.Footer>
    </Modal>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/components/ImportProductWithAI/index.jsx